<template>
    <Row type="none">
        <BreadcrumbRow :items="breadcrumbItems"/>
        <GoBackButtonRow/>
        <Modal
            :text="modalText"
            id="modal_show"
        />

        <b-modal id="pay-modal" hide-footer>
            <!-- Modal body -->
            <div class="modal-body">
                {{ $t('payWarning') }}
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal" @click="payDebts">{{
                        $t('yes')
                    }}
                </button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="$bvModal.hide('pay-modal')">
                    {{ $t('no') }}
                </button>
            </div>
        </b-modal>

        <b-modal size="xl" id="my-modal-data" :title="$t('debt')" ok-only>
            <table class="table mt-3">
                <thead>
                <tr>
                    <th scope="col" class="d-none d-lg-table-cell">{{ $t('printView.receipt') }}</th>
                    <th scope="col">{{ $t('printView.totalSum') }}</th>
                    <th scope="col">{{ $t('date') }}</th>
                    <th scope="col" class="d-none d-lg-table-cell">{{ $t('additionalInformation') }}</th>
                    <th scope="col">{{ $t('actions') }}</th>
                </tr>
                </thead>
                <tbody
                    v-for="item in getDebt.sales"
                    :key="item.id"
                >
                <tr style="cursor: pointer;">
                    <td class="d-none d-lg-table-cell" @click="goToDetails(item.id)">{{ item.id }}</td>
                    <td @click="goToDetails(item.id)">{{ showCurrencyById(item.currency.id, item.totalPrice) }}</td>
                    <td @click="goToDetails(item.id)">
                        {{ dateTimeFormat(item.createdAt, false) }}
                    </td>
                    <td class="d-none d-md-table-cell" style="color: #3EEAC1" @click="goToDetails(item.id)">
                        {{ textSplice(item.description) }}
                    </td>
                    <td>
                        <span
                            v-if="saleId !== item.id"
                            @click="saleId = item.id"

                            style="background-color: #2C0FDE; color: #FFFFFF; border-radius: 3px; padding: 4px 7px 2px 7px"
                        >&#9660;</span>
                        <span
                            v-else @click="saleId = null"

                            style="background-color: #2C0FDE; color: #FFFFFF; border-radius: 3px; padding: 2px 7px 4px 7px"
                        >&#9650;</span>
                    </td>
                </tr>
                <tr v-if="saleId === item.id">
                    <td colspan="7">
                        <Row
                            type="form-row"
                            class="col-sm-10 m-0 pt-2 my-2 justify-content-end"
                        >
                            <table class="table pr-10 pl-10" style="box-shadow: 0 4px 6px 0; border-radius: 5px">
                                <thead>
                                <tr>
                                    <th class="d-none d-sm-table-cell">#</th>
                                    <th>{{ $t('product.title') }}</th>
                                    <th>{{ $t('amount') }}</th>
                                    <th class="d-none d-sm-table-cell">{{ $t('price') }}</th>
                                    <th>{{ $t('sale.sum') }}</th>
                                </tr>
                                </thead>
                                <tbody
                                    v-for="(saleProduct, index) in item.saleProducts"
                                    :key="saleProduct.id"
                                >
                                <tr>
                                    <td class="d-none d-sm-table-cell">
                                        {{ index + 1 }}
                                    </td>
                                    <td> {{ saleProduct.product.name }}</td>
                                    <td>
                                        {{
                                            parseFloat(saleProduct.amount) + ' ' + showUnitOfMeasure(saleProduct.product.unitOfMeasure)
                                        }}
                                    </td>
                                    <td class="d-none d-sm-table-cell">
                                        {{ showCurrencyById(item.currency.id, saleProduct.price) }}
                                    </td>
                                    <td>{{
                                            showCurrencyById(item.currency.id, saleProduct.price * saleProduct.amount)
                                        }}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </Row>
                        <Row
                            type="form-row"
                            class="col-sm-10 m-0 pt-2 my-2 justify-content-end"
                        >
                            <div class="col-12 col-lg-4 mb-3 mb-lg-0" v-if="item.description !== null">
                                <span class="text-uppercase font-weight-bold">
                                   {{ $t('additionalInformation') }}
                                </span>
                                <span
                                    class="d-block"
                                    style="border: 1px solid; border-radius: 3px"
                                >
                                    {{ item.description }}
                                </span>
                            </div>
                            <div class="col-12 col-lg-8">
                                <div
                                    class=" col-12 table-bordered text-uppercase font-weight-bold d-flex "
                                    style="color: #081EE8; border-radius: 5px"
                                >
                                    <div class="col-6">
                                        <h5>{{ $t('printView.totalSum') }}</h5>
                                    </div>
                                    <div class="col-6">
                                        <h5 class="float-right">{{
                                                showCurrencyById(item.currency.id, item.totalPrice)
                                            }}</h5>
                                    </div>
                                </div>

                                <div
                                    class="col-12 table-bordered font-weight-bold d-flex"
                                    style="color: #14F00F"
                                >
                                    <div class="col-6">
                                        <h5>{{ $t('payed') }}</h5>
                                    </div>
                                    <div class="col-6">
                                        <h5 class="float-right"> {{
                                                showCurrencyById(item.currency.id, item.payedAmount)
                                            }}</h5>
                                    </div>
                                </div>

                                <div
                                    class="col-12 table-bordered font-weight-bold d-flex"
                                    style="color: #E30000"
                                >
                                    <div class="col-6">
                                        <h5>{{ $t('debt') }}</h5>
                                    </div>
                                    <div class="col-6">
                                        <h5 class="float-right">{{
                                                showCurrencyById(item.currency.id, item.totalPrice - item.payedAmount)
                                            }}</h5>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </td>
                </tr>
                </tbody>
            </table>
            <Row class="col-12 ml-lg-5">
                <div
                    class="col-12 col-lg-10 table-bordered text-uppercase font-weight-bold d-flex "
                    style="color: #081EE8"
                >
                <span class="col-6 float-left">
                    <h5>{{ $t('printView.totalSum') }}</h5>
                </span>
                    <span class="col-6 float-right">
                    <h5 class="float-right">{{ showCurrencyById(baseCurrencyId, getDebt.totalSum) }}</h5>
                </span>
                </div>

                <div
                    class="col-12 col-lg-10 table-bordered font-weight-bold d-flex"
                    style="color: #14F00F"
                >
                <span class="col-6 float-left">
                    <h5>{{ $t('payed') }}</h5>
                </span>
                    <span class="col-6 float-right">
                    <h5 class="float-right">{{ showCurrencyById(baseCurrencyId, getDebt.totalPayment) }}</h5>
                </span>
                </div>

                <div
                    class="col-12 col-lg-10 table-bordered font-weight-bold d-flex"
                    style="color: #E30000"
                >
                <span class="col-6 float-left">
                    <h5>{{ $t('debt') }}</h5>
                </span>
                    <span class="col-6">
                    <h5 class="float-right">{{ showCurrencyById(baseCurrencyId, totalDebt) }}</h5>
                </span>
                </div>
            </Row>
        </b-modal>

        <RowColumn :is-row-margin-top="true">

            <FormTag>
                <CheckBoxRow
                    v-if="this.$route.name ==='customers/add'"
                    model-name="isCompany"
                    false-text="person.title"
                    true-text="company.title"
                    :model-form="modelForm"
                />
                <template v-if="modelForm.isCompany">
                    <Row type="form-row">
                        <InputBox
                            class="mb-3"
                            model-name="companyName"
                            check-to-model="modelNotEmptyState"
                            title="company.name"
                            sm-size="5"
                            :model-form="modelForm"
                            :errors="errors"
                            :model-state="modelNotEmptyState"
                        />
                        <InputBox
                            class="mb-3"
                            model-name="companyTelephone"
                            check-to-model="modelNotEmptyState"
                            title="company.telephone"
                            sm-size="5"
                            :model-form="modelForm"
                            :errors="errors"
                            :model-state="modelPhoneOrEmpty"
                        />

                        <Column sm-size="5" v-if="this.$route.name !=='customers/add' && canSeeCustomerDebts()">
                            <LabelTag class="d-flex" style="margin-bottom: 2px">
                                <div v-if="canManagerSuppliers()" class="h-25 ml-1 mr-1">
                                    {{ $t('debt') }}:
                                </div>&nbsp;&nbsp;
                                <div v-if="canManagerSuppliers()" class="d-flex text-danger h-25 ml-1">
                                    <div>
                                        <strong style="cursor: pointer"
                                                @click="sumDebt > 0 ? $bvModal.show('my-modal-data'): ''">{{
                                                numberWithCommas(this.sumDebt)
                                            }}</strong>
                                    </div>
                                    <b-form-select v-if="sumDebt > 0" class="col-8 mx-3 mt-n2"
                                                   style="font-weight: bold; padding: 0; border: none"
                                                   v-model="currentCurrencyShortName">
                                        <b-form-select-option value="UZS">UZS</b-form-select-option>
                                        <b-form-select-option value="USD">USD</b-form-select-option>
                                        <b-form-select-option value="RUB">RUB</b-form-select-option>
                                    </b-form-select>
                                </div>
                            </LabelTag>
                            <div class="d-flex" v-if="sumDebt > 0">
                                <div class="d-flex col-9 form-control px-1 py-1">
                                    <input
                                        class="col-8"
                                        style="border: none; outline: none;"
                                        v-model="payDebt"
                                        type="number"
                                        min="0"
                                        @input="changeInput"
                                    />
                                    <b-button
                                        size="md"
                                        style="padding: 0; height: 30px; width: 100px; background-color: #6f42c1"
                                        type="submit"
                                        class="btn  col-4 "
                                        :disabled="isLoading && !payDebt"
                                        v-on:click.prevent="$bvModal.show('pay-modal'); payDebt = sumDebt"
                                    >
                                    <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status"
                                          aria-hidden="true"></span>
                                        {{ $t('filter.all') }}
                                    </b-button>
                                </div>
                                <button
                                    type="submit"
                                    class="form-control btn col-3 ml-1 text-white"
                                    style="background-color: #17A2B8"
                                    :disabled="isMore"
                                    v-on:click.prevent="$bvModal.show('pay-modal')"
                                >
                                    <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status"
                                          aria-hidden="true"></span>
                                    {{ $t('pay') }}
                                </button>
                            </div>
                            <span v-if="isMore" class="pl-3" style="color: red">
                                {{ $t('errorData') }}
                            </span>
                        </Column>

                    </Row>
                    <SearchCollapse text-button="addDebt" class="mb-3 mb-sm-0">

                        <PricePerUnit
                            model-name="debt"
                            price-label="sale.sum"
                            :model-form="modelForm"
                            :errors="errors"
                        />
                    </SearchCollapse>
                    <SubmitRow
                        v-if="canManageCustomers()"
                        :text="submitButtonName"
                        :is-disabled="hasErrorsIn(errorsCompany)"
                        :is-loading="isLoading"
                        :do-action="addOrEdit"
                    />
                </template>

                <template v-if="!modelForm.isCompany">
                    <Row type="form-row">
                        <InputBox
                            model-name="givenName"
                            title="person.givenName"
                            sm-size="5"
                            :model-form="modelForm"
                            :errors="errors"
                            check-to-model="modelNotEmptyState"
                            :column-no-top-margin="true"
                        />
                        <InputBox
                            model-name="familyName"
                            title="person.familyName"
                            sm-size="5"
                            :model-form="modelForm"
                            :column-is-fill="false"
                        />
                    </Row>

                    <Row type="form-row">
                        <InputBox
                            model-name="telephone"
                            title="person.telephone"
                            sm-size="5"
                            :model-form="modelForm"
                            :errors="errorsPerson"
                            :model-state="modelPhoneOrEmpty"
                            :no-margin-top="true"
                        />

                        <Column sm-size="5" v-if="this.$route.name !=='customers/add' && canSeeCustomerDebts()">
                            <LabelTag class="d-flex" style="margin-bottom: 2px">
                                <div v-if="canManagerSuppliers()" class="h-25 ml-1 mr-1">
                                    {{ $t('debt') }}:
                                </div>&nbsp;&nbsp;
                                <div v-if="canManagerSuppliers()" class="d-flex text-danger h-25 ml-1">
                                    <div>
                                        <strong style="cursor: pointer"
                                                @click="sumDebt > 0 ? $bvModal.show('my-modal-data') : ''">{{
                                                numberWithCommas(this.sumDebt)
                                            }}</strong>
                                    </div>
                                    <b-form-select v-if="sumDebt > 0" class="col-8 mx-3 mt-n2"
                                                   style="font-weight: bold; padding: 0; border: none"
                                                   v-model="currentCurrencyShortName">
                                        <b-form-select-option value="UZS">UZS</b-form-select-option>
                                        <b-form-select-option value="USD">USD</b-form-select-option>
                                        <b-form-select-option value="RUB">RUB</b-form-select-option>
                                    </b-form-select>
                                </div>
                            </LabelTag>
                            <div class="d-flex" v-if="sumDebt > 0">
                                <div class="d-flex col-9 form-control px-1 py-1">
                                    <input
                                        class="col-8"
                                        style="border: none; outline: none;"
                                        v-model="payDebt"
                                        type="number"
                                        min="0"
                                        @input="changeInput"
                                    />
                                    <b-button
                                        size="md"
                                        style="padding: 0; height: 30px; width: 100px; background-color: #6f42c1"
                                        type="submit"
                                        class="btn col-4"
                                        :disabled="isMore"
                                        v-on:click.prevent="$bvModal.show('pay-modal'); payDebt = sumDebt"
                                    >
                                    <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status"
                                          aria-hidden="true"></span>
                                        {{ $t('filter.all') }}
                                    </b-button>
                                </div>
                                <button
                                    type="submit"
                                    class="form-control btn col-3 ml-1 text-white"
                                    style="background-color: #17A2B8"
                                    :disabled="isLoading && !isMore"
                                    v-on:click.prevent="$bvModal.show('pay-modal')"
                                >
                                    <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status"
                                          aria-hidden="true"></span>
                                    {{ $t('pay') }}
                                </button>
                            </div>
                            <span v-if="isMore" class="pl-3" style="color: red">
                                {{ $t('errorData') }}
                            </span>
                        </Column>

                    </Row>

                    <CheckBoxRow
                        v-if="canManageCustomers()"
                        model-name="gender"
                        false-text="person.gender.woman"
                        true-text="person.gender.man"
                        :model-form="modelForm"
                        :unchecked-value="0"
                        :checked-value="1"
                    />

                    <SearchCollapse text-button="addDebt" class="mb-3 mb-sm-0">
                        <PricePerUnit
                            model-name="debt"
                            price-label="sale.sum"
                            :model-form="modelForm"
                            :errors="errors"
                        />
                    </SearchCollapse>

                    <SubmitRow
                        v-if="canManageCustomers()"
                        :text="submitButtonName"
                        :is-disabled="hasErrorsIn(errorsPerson)"
                        :is-loading="isLoading"
                        :do-action="addOrEdit"
                    />
                </template>
            </FormTag>

        </RowColumn>

        <button
            @click="showOrHideSalesHistory"
            class="mt-3"
            style="border: none; outline: none; background-color: #FFFFFF; color: #6f42c1; font-size: 20px"
        >
            <ins> {{ $t('sale.purchaseHistory') }}</ins>
            <span v-if="hasSalesCustomer">&#9650;</span> <span v-else>&#9660;</span>
        </button>
        <span v-show="hasSalesCustomer">
            <RowColumn>

                <SearchCollapse class="mb-3 mb-sm-0">
                    <div class="text-center mb-2 justify-content-around">
                        <b-form-group>
                            <b-form-radio-group
                                v-model="search.isPayed"
                                :options="options"
                            ></b-form-radio-group>
                        </b-form-group>
                    </div>
                    <div class="justify-content-around p-0 col-md-8 col-lg-7 d-md-flex">
                        <b-form-input
                            v-model="search.sumMin"
                            :placeholder="$t('filter.fromSum')"
                            class="mr-md-1"
                            type="number"
                            @keyup.enter="searchSalesInfo"
                        >
                        </b-form-input>
                        <b-form-input
                            v-model="search.sumMax"
                            :placeholder="$t('filter.toSum')"
                            class="mr-md-1"
                            type="number"
                            @keyup.enter="searchSalesInfo"
                        >
                        </b-form-input>
                    </div>

                    <div class="d-flex mb-1 justify-content-between mt-3">
                        <div class="d-flex flex-wrap justify-content-start col-11 pl-0">
                            <b-button
                                style="outline: none; border: none; background-color: #ffffff; padding: 0"
                                v-b-modal.my-modal>
                                <IconButton
                                    icon="calendar-alt"
                                    title="filter.thisDay"
                                />
                            </b-button>
                            <b-modal id="my-modal" :title="$t('filter.thisDay')">
                                <b-input-group>
                                    <b-form-input
                                        v-model="search.after"
                                        type="text"
                                        :placeholder="$t('filter.fromDateToDate')"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-form-datepicker
                                            v-model="search.after"
                                            button-only
                                            locale="en-US"
                                        ></b-form-datepicker>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-modal>
                            <span class="date text-primary mr-sm-3">{{ this.search.after }}</span>
                            <b-button
                                v-b-modal.modal-1
                                style="outline: none; border: none; background-color: #ffffff ; padding: 0">
                                <IconButton
                                    icon="calendar-alt"
                                    title="filter.toDay"
                                    :has-margin-right="false"
                                />
                            </b-button>
                            <b-modal id="modal-1" :title="$t('filter.toDay')">
                                <b-input-group>
                                    <b-form-input
                                        v-model="search.before"
                                        type="text"
                                        :placeholder="$t('filter.fromDateToDate')"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-form-datepicker
                                            v-model="search.before"
                                            button-only
                                            locale="en-US"
                                        ></b-form-datepicker>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-modal>
                            <span class="date text-primary ml-1">{{ this.search.before }}</span>
                        </div>
                        <div class="d-flex justify-content-end col-1">
                            <IconButton
                                title="search"
                                :do-action="searchSalesInfo"
                                icon="search"
                            />
                            <IconButton
                                title="filter.clear"
                                :do-action="resetSaleSearchInfo"
                                icon="eraser"
                                :has-margin-right="false"
                            />
                        </div>

                    </div>
                </SearchCollapse>
            </RowColumn>
            <h5 class="float-right">
                {{ $t('totalSalesAmount') }}:
                <span
                    class="text-primary">{{ showCurrencyById(getCustomerSalesTotalAmount[1], getCustomerSalesTotalAmount[0]) }}</span>
            </h5>
            <div>
                <table class="table">
                    <thead>
                    <tr>
                        <th class="d-none d-md-table-cell"> #</th>
                        <th>{{ $t('date') }}</th>
                        <th>{{ $t('sale.sum') }}</th>
                        <th class="d-none d-md-table-cell">{{ $t('sale.cash') }}</th>
                        <th class="d-none d-md-table-cell">{{ $t('statistics.categories.bankCard') }}</th>
                        <th class="d-none d-md-table-cell">{{ $t('statistics.categories.moneyTransfer') }}</th>
                        <th class="d-none d-md-table-cell">{{ $t('statistics.categories.debt') }}</th>
                        <th>{{ $t('actions') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(sale, index ) of getSales" :key="index"
                        :style="{backgroundColor: backgroundColor(sale.debt)}">
                        <td class="d-none d-md-table-cell">
                            {{ sale.id }}
                        </td>

                        <td>
                            {{ dateTimeFormat(sale.createdAt, true) }}
                        </td>

                        <td v-if="sale.totalPrice > 0">
                            {{ showCurrencyById(sale.currency.id, sale.totalPrice) }}
                        </td>
                        <td v-else class="text-center d-none d-md-table-cell"> - </td>

                        <td v-if="sale.cash > 0" class="d-none d-md-table-cell">
                            {{ showCurrencyById(sale.currency.id, sale.cash) }}
                        </td>
                        <td v-else class="text-center d-none d-md-table-cell"> - </td>

                        <td v-if="sale.bankCard > 0" class="d-none d-md-table-cell">
                            {{ showCurrencyById(sale.currency.id, sale.bankCard) }}
                        </td>
                        <td v-else class="text-center d-none d-md-table-cell"> - </td>

                        <td v-if="sale.moneyTransfer > 0" class="d-none d-md-table-cell">
                            {{ showCurrencyById(sale.currency.id, sale.moneyTransfer) }}
                        </td>
                        <td v-else class="text-center d-none d-md-table-cell"> - </td>

                        <td v-if="sale.debt > 0" class="d-none d-md-table-cell">
                            {{ showCurrencyById(sale.currency.id, sale.debt) }}
                        </td>
                        <td v-else class="text-center d-none d-md-table-cell"> - </td>

                        <td class="text-md-center">
                            <IconButton title="view" icon="eye" @click.native="getSaleId(sale.id)"/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <RowColumn>
                <Pagination
                    :search="search"
                    :base-url="'customersId/' + this.search.customerId"
                    :total-items="getSalesTotalCount"
                    method-name="fetchSalesCustomer"/>
            </RowColumn>
        </span>

    </Row>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import validatorMixin from "../../mixin/validatorMixin";
import Row from "../../components/html/Row";
import RowColumn from "../../components/RowColumn";
import FormTag from "../../components/html/FormTag";
import BreadcrumbRow from "../../components/BreadcrumbRow";
import GoBackButtonRow from "../../components/GoBackButtonRow";
import InputBox from "../../components/InputBox";
import CheckBoxRow from "../../components/CheckBoxRow";
import SubmitRow from "../../components/SubmitRow";
import Modal from "../../components/html/Modal";
import accessMixin from "../../mixin/accessMixin";
import currencyFormatMixin from "../../mixin/currencyFormatMixin";
import LabelTag from "../../components/html/LabelTag";
import Column from "../../components/html/Column";
import IconButton from "@/components/IconButton";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import SearchCollapse from "../../components/SearchCollapse";
import Pagination from "@/components/html/Pagination";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import PricePerUnit from "@/components/PricePerUnit";

export default {
    name: "CustomerAdd",
    mixins: [validatorMixin, accessMixin, currencyFormatMixin, dateFormattingMixin, currencyRateMixin],
    computed: {
        ...mapGetters([
            'getCustomer',
            'getDebt',
            'getUserCompanyId',
            'getCurrencyByShortName',
            'getSales',
            'getSalesTotalCount',
            'getCustomerSalesTotalAmount'
        ]),
        errorsCompany() {
            return {
                companyName: this.errors.companyName,
            }
        },
        errorsPerson() {
            return {
                givenName: this.errors.givenName,
            }
        }
    },
    data() {
        return {
            saleId: null,
            hasSalesCustomer: false,
            color: '#FFEEBA',
            search: {
                customerId: this.$route.params.id,
                isPayed: null,
                after: '',
                before: '',
                totalPriceMin: '',
                totalPriceMax: '',
                page: this.$route.params.page
            },
            options: [
                {text: this.$t('filter.all'), value: null},
                {text: this.$t('payed'), value: true},
                {text: this.$t('onCredit'), value: false}
            ],
            submitButtonName: 'add',
            modalText: '',
            isLoading: false,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'customer.title', url: 'customers'},
                {name: 'add'},
            ],
            errors: {
                companyName: null,
                companyTelephone: null,
                givenName: null,
                personFamilyName: null,
                personGender: null,
                personTelephone: null,
                debt: null,
                currencyId: null,
            },
            modelForm: {
                id: null,
                isCompany: true,
                companyName: '',
                companyTelephone: '',
                givenName: '',
                familyName: '',
                gender: 1,
                telephone: '',
                debt: '',
                currencyId: 0,
            },
            customerDebt: 0,
            customerName: '',
            payDebt: null,
            totalDebt: 0,
            sumDebt: 0,
            isMore: false
        }
    },
    watch: {
        'currentCurrencyShortName'(newVal, oldVal) {
            this.sumDebt = this.calculateAmountByBaseCurrency(this.sumDebt, oldVal, newVal)
        },
    },
    methods: {
        ...mapMutations(['updateNewSaleId']),
        async getSaleId(id) {
            this.updateNewSaleId(id)
            await this.$i18nHelper.toUrl('sales/transactions/')
        },
        textSplice(text) {
            if (text !== null) {
                if (text.length > 20) {
                    return text.slice(0, 20) + ' . . .'
                }
                return text
            }

            return "-"
        },
        getCustomerName(customer) {
            return customer.isCompany ?
                customer.customerCompany.name :
                customer.person.givenName + ' ' + customer.person.familyName
        },
        changeInput() {
            this.isMore = parseInt(this.payDebt) > parseInt(this.sumDebt);
        },
        goToDetails(id) {
            this.$i18nHelper.toUrl('sales/transactions/' + id)
        },
        showOrHideSalesHistory() {
            this.hasSalesCustomer = !this.hasSalesCustomer
        },
        resetSaleSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchSalesInfo()
        },
        backgroundColor(amount) {
            if (amount > 0) {
                return this.color
            }
        },
        searchSalesInfo() {
            this.$root.showOverlay = true
            this.search.page = 1

            this.fetchSalesCustomer(this.search)
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        ...mapActions([
            'putCustomer',
            'pushCustomer',
            'fetchCustomer',
            'fetchUser',
            'fetchCompany',
            'fetchDebt',
            'payToCustomer',
            'fetchSalesCustomer',
            'searchSales',
            'fetchCustomerSalesTotalAmount'
        ]),
        payDebts() {
            this.$bvModal.hide('pay-modal')
            this.$root.showOverlay = true

            this.payToCustomer({
                id: this.$route.params.id,
                paymentAmount: parseFloat(this.payDebt),
                currency: this.getCurrencyByShortName(this.currentCurrencyShortName)['@id']
            })
                .then(() => {
                    this.$router.go(0)
                })
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        addOrEdit() {
            if (this.$route.name === 'customers/add') {
                this.isLoading = true

                if (this.modelForm.isCompany) {
                    this.pushCustomer({
                        isCompany: this.modelForm.isCompany,
                        companyName: this.modelForm.companyName,
                        companyTelephone: this.modelForm.companyTelephone,
                        debt: this.modelForm.debt,
                        currency: '/api/currencies/' + this.modelForm.currencyId,
                    })
                        .then(() => {
                            this.$i18nHelper.toUrl('customers')
                        })
                        .catch((reason) => {
                            if (reason === 'You have not available credits') {
                                this.modalText = this.$t('error.overLimit')
                                this.$bvModal.show('modal_show')
                            } else {
                                this.modalText = reason
                                this.$bvModal.show('modal_show')
                            }
                        })
                } else {
                    this.pushCustomer({
                        isCompany: this.modelForm.isCompany,
                        personGivenName: this.modelForm.givenName,
                        personFamilyName: this.modelForm.familyName,
                        personGender: this.modelForm.gender,
                        personTelephone: this.modelForm.telephone,
                        debt: this.modelForm.debt,
                        currency: '/api/currencies/' + this.modelForm.currencyId,
                    })
                        .then(() => {
                            this.$i18nHelper.toUrl('customers')
                        })
                        .catch((reason) => {
                            this.modalText = reason
                            this.$bvModal.show('modal_show')
                        })
                }
                setTimeout(() => {
                    this.isLoading = false
                }, 5000)
            } else {
                this.isLoading = true
                if (this.modelForm.isCompany) {
                    this.putCustomer({
                        url: 'customer_companies',
                        id: this.modelForm.id,
                        name: this.modelForm.companyName,
                        telephone: this.modelForm.companyTelephone,
                    })
                        .then(() => {
                            this.$i18nHelper.toUrl('customers')
                        })
                        .catch((reason) => {
                            this.modalText = reason
                            this.$bvModal.show('modal_show')
                        })
                } else {
                    this.putCustomer({
                        url: 'people',
                        id: this.modelForm.id,
                        givenName: this.modelForm.givenName,
                        familyName: this.modelForm.familyName,
                        gender: this.modelForm.gender,
                        telephone: this.modelForm.telephone
                    })
                        .then(response => {
                            console.log(response['@id'])
                            this.$i18nHelper.toUrl('customers')
                        })
                        .catch((reason) => {
                            this.modalText = reason
                            this.$bvModal.show('modal_show')
                        })
                }

                this.putCustomer({
                    url: 'customers',
                    id: this.$route.params.id,
                    debt: (Number(this.modelForm.debt) + Number(this.getCustomer.debt)).toString(),
                    currency: '/api/currencies/' + this.modelForm.currencyId,
                })
                    .then(() => {
                        this.$i18nHelper.toUrl('customers')
                    })
                    .catch((reason) => {
                        this.modalText = reason
                        this.$bvModal.show('modal_show')
                    })

                setTimeout(() => {
                    this.isLoading = false
                }, 5000)
            }
        },
    },
    mounted() {
        if (this.$route.name !== 'customers/add') {
            this.$root.showOverlay = true
            this.submitButtonName = 'edit'

            this.fetchCustomer(this.$route.params.id)
                .finally(() => {
                    if (this.canSeeCustomerDebts()) {
                        this.fetchCustomerSalesTotalAmount(this.$route.params.id)
                        this.fetchDebt(this.$route.params.id)
                            .then(() => {
                                this.sumDebt = this.getDebt.customerDebt.toFixed(2)
                                this.totalDebt = this.getDebt.customerDebt.toFixed(2)
                            })
                    }

                    this.customerName = this.getCustomerName(this.getCustomer)

                    if (!this.getCustomer.isCompany) {
                        this.modelForm.isCompany = false
                        this.modelForm.id = this.getCustomer.person.id
                        this.modelForm.givenName = this.getCustomer.person.givenName
                        this.modelForm.familyName = this.getCustomer.person.familyName
                        this.modelForm.telephone = this.getCustomer.person.telephone ? this.getCustomer.person.telephone : ''
                        this.modelForm.gender = this.getCustomer.person.gender
                    } else {
                        this.modelForm.id = this.getCustomer.customerCompany.id
                        this.modelForm.companyName = this.getCustomer.customerCompany.name
                        this.modelForm.companyTelephone = this.getCustomer.customerCompany.telephone ? this.getCustomer.customerCompany.telephone : ''
                    }

                    this.$root.showOverlay = false
                })
        }
    },
    components: {
        PricePerUnit,
        Pagination,
        IconButton,
        SubmitRow,
        CheckBoxRow,
        InputBox,
        GoBackButtonRow,
        BreadcrumbRow,
        FormTag,
        RowColumn,
        Row,
        Modal,
        LabelTag,
        Column,
        SearchCollapse
    },
}
</script>
